/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */

import type { RedirectContext } from '../types'
import { FEATURE_FLAGS } from '@/lib/consts.js'
import { replaceWithResolvedRoute } from '../utils/replace-with-resolved-route'

type ContextWithEppo = RedirectContext & { eppo: { ff: (flag: string) => boolean } }

export const deleteAccountRedirect = ({ store, router, route, eppo }: ContextWithEppo): unknown => {
  const redirectionName = route.params?.redirection?.name
  if (redirectionName === 'settings.booksy-app.delete-your-account') {
    return router.push({ name: redirectionName })
  }

  const business = store.state.business?.business
  const deletionRequested = eppo.ff(FEATURE_FLAGS.Feature_AccountDeletionViews) && business?.deletion_requested
  if (!deletionRequested) return

  // non-owner is redirected to forbidden by restricted-by-subscription guard
  if (!store.getters['identity/isOwner']) return

  return replaceWithResolvedRoute(router, {
    name: 'settings.subscription.payment-method-info',
    params: {
      businessId: store.getters['business/businessId'],
      type: 'account-deletion',
    },
  })
}
